import { Button, Result } from "antd";
import React from "react";
interface Props {}
const Error401 = (props: Props) => {
  return <Result
  // status="404"
  title="Unauthorized"
  subTitle="You are not authorized to visit this page."
  extra={<Button type="primary" href="/dashboard">My home</Button>}
/>
};
export default Error401;
